import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { makeStyles, } from '@material-ui/core/styles';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import { usePhoneView } from '../../hooks/usePhoneView';
var useStyles = makeStyles(function () { return ({
    dialogTitle: {
        fontFamily: 'Montserrat,sans-serif',
        fontWeight: 500,
        lineHeight: 1.6,
    },
}); });
export default function PreventTransitionDialog(props) {
    var t = useTranslation().t;
    var classes = useStyles();
    var phoneView = usePhoneView();
    var handleCancel = props.handleCancel, handleClose = props.handleClose, handleDiscard = props.handleDiscard, open = props.open, message = props.message, title = props.title, _a = props.discardLabel, discardLabel = _a === void 0 ? t('Yes') : _a, _b = props.cancelLabel, cancelLabel = _b === void 0 ? t('No') : _b;
    return (React.createElement(Dialog, { open: open, onClose: handleClose },
        React.createElement(DialogTitle, null,
            React.createElement("div", { className: classes.dialogTitle, style: { fontSize: phoneView ? '1.1rem' : '1.25rem' } }, title)),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null, message)),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: handleDiscard, color: 'danger', size: 'small' }, discardLabel),
            React.createElement(Button, { onClick: handleCancel, size: 'small' }, cancelLabel))));
}
//# sourceMappingURL=PreventTransitionDialog.js.map